import { getDateRangeFilterProperty, getReportConfig } from 'reporting-data/report/configReportGetters';
import { Map as ImmutableMap, List, Set as ImmutableSet, fromJS } from 'immutable';
import { DEALS } from 'reporting-data/constants/dataTypes';
import { getDataTypeFromConfig } from 'reporting-data/report/reportGetters';
import { useEffect, useState } from 'react';
import { waitForPromises } from 'reporting-ui-components/lib/waitForPromises';
// @ts-expect-error Untyped dependency
import getPropertyGroups from 'reporting-data/properties/groups';
import memoize from 'transmute/memoize';
const DATE_TYPES = ImmutableSet(['datetime', 'date', 'timestamp']);
const getOptionFromProperty = property => {
  return {
    text: property.get('label'),
    value: property.get('name')
  };
};
const NONE_PIPELINE_PROPERTIES_GROUP_NAME = 'NONE_PIPELINE_PROPERTIES_GROUP_NAME';
const getStageOptionsGroupedByPipeline = (group, filter) => {
  const pipelineGroups = group.get('properties').reduce((groups, property) => {
    if (!filter(property)) {
      return groups;
    }
    const pipelineId = property.getIn(['pipeline', 'pipelineId'], '');
    if (pipelineId) {
      if (!groups.has(pipelineId)) {
        return groups.set(pipelineId, ImmutableMap({
          pipeline: property.get('pipeline'),
          properties: List.of(property)
        }));
      }
      return groups.updateIn([pipelineId, 'properties'], properties => properties.push(property));
    }

    // Stores non-pipeline properties in a separate group
    return groups.update(NONE_PIPELINE_PROPERTIES_GROUP_NAME, (currentValue = fromJS({
      properties: []
    })) => {
      const updatedProperties = currentValue.get('properties').push(property);
      return group.set('properties', updatedProperties);
    });
  }, ImmutableMap());
  const nonPipelineOptions = pipelineGroups.getIn([NONE_PIPELINE_PROPERTIES_GROUP_NAME, 'properties'], ImmutableMap()).map(getOptionFromProperty);
  const pipelineOptions = pipelineGroups.remove(NONE_PIPELINE_PROPERTIES_GROUP_NAME).valueSeq().map(pipelineGroup => ({
    text: pipelineGroup.getIn(['pipeline', 'label']),
    options: pipelineGroup.get('properties').map(getOptionFromProperty).toArray()
  }));
  return nonPipelineOptions.concat(pipelineOptions).toArray();
};
const getDateProperties = memoize((propertyGroupPromise, dataType, currentDateProperty) => {
  return propertyGroupPromise.then(groups => groups.map(group => {
    const filter = property => {
      return DATE_TYPES.has(property.get('type')) && (!property.get('hidden') || property.get('name') === currentDateProperty);
    };
    if (group.get('name') === 'dealstages' && dataType === DEALS) {
      return {
        text: group.get('displayName'),
        options: getStageOptionsGroupedByPipeline(group, filter)
      };
    }
    return {
      text: group.get('displayName'),
      options: group.get('properties').filter(filter).map(getOptionFromProperty).sortBy(option => option.text.toLowerCase()).toArray()
    };
  }).filter(group => group.options.length > 0).toArray());
});
export const useDatePropertyEditorOptions = ({
  report,
  config,
  getPropertyGroups: customGetPropertyGroups
}) => {
  const [datePropertyOptions, setDatePropertyOptions] = useState({
    status: 'pending',
    value: undefined,
    error: undefined
  });
  config = config || getReportConfig(report);
  const dataType = getDataTypeFromConfig(config);
  const dateProperty = getDateRangeFilterProperty(config);
  useEffect(() => {
    const getPropertyGroupsPromise = customGetPropertyGroups ? customGetPropertyGroups(report) : getPropertyGroups(dataType);
    waitForPromises({
      dateProperties: {
        setStateFunction: setDatePropertyOptions,
        promise: getDateProperties(getPropertyGroupsPromise, dataType, dateProperty)
      }
    });
  }, [dataType, dateProperty, report, customGetPropertyGroups]);
  return datePropertyOptions;
};